(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["watchheads-back"] && !Shopify.designMode) return;
  try {
    function setWatchheadsBackLink(){
  document.querySelectorAll('[data-watchheads-back]').forEach(link=>{
    try{
      const previous=new URL(document.referrer);
      if(previous.origin===location.origin && previous.pathname!==location.pathname && previous.pathname!=='/password'){
        link.href=previous.href;
      } else {
        const destination=new URL(link.href);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');
        if(preview) destination.searchParams.set('preview_theme_id',preview);
        link.href=destination.href;
      }
    }catch{}
  });
}
setWatchheadsBackLink();
document.addEventListener('shopify:section:load',setWatchheadsBackLink);
window.addEventListener('pageshow',setWatchheadsBackLink);
  } catch(e) { console.error(e); }
})();

})();
